module.exports = {"610526001":"奉先街道","610526002":"紫荆街道","610526101":"罕井镇","610526102":"孙镇","610526103":"兴镇","610526104":"党睦镇","610526105":"高阳镇","610526106":"永丰镇","610526107":"荆姚镇","610526108":"苏坊镇","610526109":"龙阳镇","610526112":"洛滨镇","610526113":"陈庄镇","610526114":"桥陵镇","610526116":"尧山镇","610526117":"椿林镇","610526118":"龙池镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610526.json
// module id = 2965
// module chunks = 0